import { TypedUseSelectorHook, useSelector } from "react-redux";
import { GameState, gameActions } from "./GameReducer";
import { AppState, useAppDispatch } from "@grassrootly/rn-core";
import useBaseRequest from "../BaseRequest";
import { GetGameById, IPlayerGame } from "@grassrootly/api";

const useGameSelector: TypedUseSelectorHook<{ games: GameState } & AppState> = useSelector;

export const useLatestGame = () =>
  useGameSelector(({ games }) => {
    if (!games.latestGameId) return null;
    return games.games[games.latestGameId] || null;
  });

export const useNextGames = (): IPlayerGame[] => useGameSelector(({ games }) => games.nextGames);

// Selector for using only "earliest" of the upcoming games (next game)
export const useNextGame = (): IPlayerGame | null => {
  return useGameSelector(({ games }) => {
    if (!games.nextGames || !games.nextGames.length) return null;
    return games.nextGames[0];
  });
};

export const useFeaturedGame = (): IPlayerGame | null => {
  return useGameSelector(({ games }) => {
    return games.featuredGame;
  });
};

export const usePreviousGames = (): IPlayerGame[] => useGameSelector(({ games })=> games.previousGames);

export const useGame = (id: number) => useGameSelector(({ games }) => games.games[id] || null);

export const useFetchGame = (id: number) => {
  const dispatch = useAppDispatch();
  const game = useGame(id);
  const { execute, loading } = useBaseRequest(GetGameById, {
    initialPayload: { id },
    autoFetch: true,
    onCompleted: (data) => {
      if (!data) return;
      dispatch(gameActions.setGame(data));
    },
  });

  const fetchGame = () => {
    execute({ id });
  };

  return { fetching: loading, fetchGame, game };
};

export const useGameVotes = (id: number) => useGameSelector(({ games }) => games.gameVotes[id] || null);
